import React from 'react';
import { getWindowConfig } from 'config';

import get from 'lodash/get'
import GoogleMapReact from 'google-map-react';
import supercluster from 'points-cluster';
import ClusterMarker from 'components/mapElements/ClusterMarker';
import Marker from './Marker';

const MAP = {
  defaultZoom: 10,
  defaultCenter: { lat: 10.386489034746074, lng: 105.4054715851609 },
  options: {
    maxZoom: 19,
  },
};

class Map extends React.PureComponent {

  markers = [];
  state = {
    isLoaded: false,
    mapOptions: {
      center: { lat: 10.386489034746074, lng: 105.4054715851609 },
      zoom: 12,
    },
    clusters: [],
  };

  getClusters = () => {
    const {data = []} = this.props
    const {mapOptions} = this.state

    const clusters = supercluster(
      data.map((item) => {
        return {
          id: get(item, 'Area._id'),
          lat: get(item, 'Area.Lat'),
          lng: get(item, 'Area.Lng'),
          Species: get(item, 'Species'),
          Area: get(item, 'Area'),
      ProjectName: get(item, 'ProjectName'),
          color: item.color
        };
      }),
      {
        minZoom: 0,
        maxZoom: 16,
        radius: 120,
        extent: 1024,
      }
    );

    return clusters(mapOptions);
  };

  createClusters = () => {
    this.setState({
      clusters: this.state.mapOptions.bounds
        ? this.getClusters(this.props).map(({ wx, wy, numPoints, points }) => {

            return {
              lat: wy,
              lng: wx,
              numPoints,
              id: `${numPoints}_${points[0].id}`,
              points,
            };
          })
        : [],
    });
  };

  handleMapChange = ({ center, zoom, bounds }) => {
    this.setState(
      {
        mapOptions: {
          center,
          zoom,
          bounds,
        },
      },
      () => {
        this.createClusters(this.props);
      }
    );
  };

  render() {
    return (
      <div style={{ height: '80vh', width: '100%' }}>
        <GoogleMapReact
          defaultZoom={MAP.defaultZoom}
          defaultCenter={MAP.defaultCenter}
          onChange={this.handleMapChange}
          options={{
            mapTypeId: 'hybrid',
          }}
          bootstrapURLKeys={{ key: getWindowConfig().googleApiKey }}
        >
          {this.state.clusters.map((item) => {
            if (item.numPoints === 1) {
              return (
                <Marker
                  key={item.id}
                  lat={item.points[0].lat}
                  lng={item.points[0].lng}
                  color={item.points[0].color}
                  Area={item.points[0].Area}
                  Species={item.points[0].Species}
                  ProjectName={item.points[0].ProjectName}
                />
              );
            }

            return (
              <ClusterMarker
                key={item.id}
                lat={item.lat}
                lng={item.lng}
                text={item.numPoints}
              ></ClusterMarker>
            );
          })}
        </GoogleMapReact>
      </div>
    );
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityList/Maps/index.js